<template>
    <main>
        <Banner />
        <Info />
    </main>
</template>

<script>
import Banner from './_banner'
import Info from './_info'

export default {
    components: {
        Banner,
        Info,
    }
}
</script>